<div class="header-container">
  <h1>{{ 'app.title' | transloco }}</h1>
  <h2>{{ (title$ | async) | transloco }}</h2>
</div>

<div class="content-container">
  <router-outlet></router-outlet>
</div>
